export const BaseUrl = {
  baseUrl: "http://167.114.96.66:3005/",
}